var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeTileBeyondData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "89px",
    viewBox: "0 0 113 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.951,0.5 C3.836,0.5 0.5,3.836 0.5,7.95 L0.5,7.95 L0.5,81.05 C0.5,85.164 3.836,88.5 7.951,88.5 L7.951,88.5 L105.05,88.5 C109.165,88.5 112.5,85.164 112.5,81.05 L112.5,81.05 L112.5,7.95 C112.5,3.836 109.165,0.5 105.05,0.5 L105.05,0.5 L7.951,0.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop---Beyond-Data",
    transform: "translate(-38.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(38.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#BF1F41",
    mask: "url(#mask-2)",
    points: "68 93 90.5 93 90.5 -17 68 -17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#2BAFA9",
    mask: "url(#mask-2)",
    points: "38 93 80.5 93 80.5 -17 38 -17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#672770",
    mask: "url(#mask-2)",
    points: "0 93 56.5 93 56.5 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#4E4E4E",
    mask: "url(#mask-2)",
    points: "90 93 112.5 93 112.5 -17 90 -17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4165,49.8125 L14.4995,49.8125 C13.3955,49.8125 12.4995,48.9165 12.4995,47.8125 C12.4995,46.7085 13.3955,45.8125 14.4995,45.8125 L43.4165,45.8125 C44.5205,45.8125 45.4165,46.7085 45.4165,47.8125 C45.4165,48.9165 44.5205,49.8125 43.4165,49.8125",
    id: "Fill-7",
    fill: "#F2E9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4443,59.8125 L14.5003,59.8125 C13.3953,59.8125 12.5003,58.9165 12.5003,57.8125 C12.5003,56.7085 13.3953,55.8125 14.5003,55.8125 L32.4443,55.8125 C33.5483,55.8125 34.4443,56.7085 34.4443,57.8125 C34.4443,58.9165 33.5483,59.8125 32.4443,59.8125",
    id: "Fill-9",
    fill: "#F2E9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6079,30.5625 L16.3919,30.5625 C14.2429,30.5625 12.4999,28.8205 12.4999,26.6695 L12.4999,16.4555 C12.4999,14.3045 14.2429,12.5625 16.3919,12.5625 L41.6079,12.5625 C43.7569,12.5625 45.4999,14.3045 45.4999,16.4555 L45.4999,26.6695 C45.4999,28.8205 43.7569,30.5625 41.6079,30.5625",
    id: "Fill-11",
    fill: "#F2E9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.0498,88.5 L7.9498,88.5 C3.8358,88.5 0.4998,85.164 0.4998,81.05 L0.4998,7.95 C0.4998,3.836 3.8358,0.5 7.9498,0.5 L105.0498,0.5 C109.1648,0.5 112.4998,3.836 112.4998,7.95 L112.4998,81.05 C112.4998,85.164 109.1648,88.5 105.0498,88.5 Z",
    id: "Stroke-13",
    stroke: "#8D8F92",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeTileBeyondData);
export default __webpack_public_path__ + "static/media/themeTile_BeyondData.5ed602bad18db2db9828aec3c8042078.svg";
export { ForwardRef as ReactComponent };